export default {"src":"/_next/static/media/sync_vs_streaks.33cace92.svg","height":43,"width":61,"blurWidth":0,"blurHeight":0};